export default __webpack_public_path__ + "static/media/banner3.ada53621.webp";